import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { AuthProvider } from './context/ApiKeyContext';
import { LanguageProvider } from './context/LanguageContext';
import LoginPage from './components/LoginPage';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import EditorTemplates from './pages/EditorTemplates';
import Contestacao from './pages/Contestacao';
import ProcessamentosPage from './pages/ProcessamentosPage';
import ContestacaoPage from './pages/ContestacaoPage';
import AccountPage from './pages/AccountPage';
import AccountPageSimple from './pages/AccountPageSimple';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(216, 78, 43)', // Laranja principal da marca
    },
    secondary: {
      main: '#643184', // Roxo para contraste
    },
    background: {
      default: '#f5f5f5', // Cinza claro para fundos
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Verificar se existe um token de autenticação salvo no localStorage
  useEffect(() => {
    const token = localStorage.getItem('ikaro_auth_token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  // Componente para rotas protegidas que requerem autenticação
  const PrivateRoute = ({ children, ...rest }) => {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          isAuthenticated ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
        }
      />
    );
  };

  return (
    <LanguageProvider>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <div className="App">
              <Switch>
              <Route path="/login">
                {isAuthenticated ? (
                  <Redirect to="/dashboard" />
                ) : (
                  <LoginPage onLoginSuccess={() => setIsAuthenticated(true)} />
                )}
              </Route>
              
              <Route path="/account">
                <AccountPage />
              </Route>
              
              <Route path="/account-test">
                <AccountPageSimple />
              </Route>
              
              <PrivateRoute path="/dashboard">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <Dashboard />
                </MainLayout>
              </PrivateRoute>
              
              <PrivateRoute path="/editor-templates">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <EditorTemplates />
                </MainLayout>
              </PrivateRoute>
              
              <PrivateRoute path="/processamentos">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <ProcessamentosPage />
                </MainLayout>
              </PrivateRoute>
              
              <PrivateRoute path="/contestacoes">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <ContestacaoPage />
                </MainLayout>
              </PrivateRoute>
              
              <PrivateRoute path="/contestacao/nova">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <Contestacao />
                </MainLayout>
              </PrivateRoute>
              
              <PrivateRoute path="/processamento/novo">
                <MainLayout 
                  isAuthenticated={isAuthenticated}
                  setIsAuthenticated={setIsAuthenticated}
                >
                  <EditorTemplates />
                </MainLayout>
              </PrivateRoute>
              
              <Route exact path="/">
                <Redirect to={isAuthenticated ? "/dashboard" : "/login"} />
              </Route>
              </Switch>
            </div>
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App; 